// import React, { useState, useEffect } from "react";
// import { ref, get } from "firebase/database";
// import { database as db } from "../../FirebaseConfig"; // Adjust based on your Firebase config
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, FreeMode } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/free-mode";
// import { useNavigate } from "react-router-dom";

// const KnowledgeHub = () => {
//   const [blogPosts, setBlogPosts] = useState([]);
//   const navigate = useNavigate();

//   const handleClick = (id)=>{

//     navigate(`/blog?id=${id}`);

//   }
//   useEffect(() => {
//     const fetchBlogs = async () => {
//       try {
//         const snapshot = await get(ref(db, "blogs")); // Fetch from 'blogs' node in Realtime Database
//         if (snapshot.exists()) {
//           const data = snapshot.val();
//           const formattedData = Object.keys(data).map((key) => ({
//             id: key,
//             ...data[key],
//           }));
//           setBlogPosts(formattedData);
//         }
//       } catch (error) {
//         console.error("Error fetching blog posts:", error);
//       }
//     };

//     fetchBlogs();
//   }, []);

//   return (
//     <div className="relative  bg-yellow-50 overflow-hidden">
//       {/* Internal CSS for Meteor Effect */}
//       <style jsx>{`
//         @keyframes meteor {
//           0% { transform: translate(-200px, -200px) rotate(45deg); opacity: 0.3; }
//           30% { opacity: 0.5; }
//           70% { opacity: 0.2; }
//           100% { transform: translate(500px, 500px) rotate(45deg); opacity: 0; }
//         }
//         .meteor {
//           position: absolute;
//           width: 150px;
//           height: 3px;
//           background: linear-gradient(90deg, #FFB800, #FFE082);
//           animation: meteor 5s linear infinite;
//         }
//         .background-gradient {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: linear-gradient(135deg, #FFF8E1 0%, #FFE082 100%);
//           pointer-events: none;
//         }
//       `}</style>

//       {/* Background gradient */}
//       <div className="background-gradient"></div>

//       {/* Meteor Effects */}
//       {[...Array(15)].map((_, i) => (
//         <div
//           key={i}
//           className="meteor"
//           style={{
//             top: `${Math.random() * 100}%`,
//             left: `${Math.random() * 100}%`,
//             animationDelay: `${Math.random() * 3}s`,
//             opacity: 0.3,
//           }}
//         />
//       ))}

//       {/* Content */}
//       <div className="container mx-auto px-4 py-16 relative z-10">
//         <h1 className="text-xl md:text-4xl font-bold text-gray-800 text-center mb-4">
//           TGHC KNOWLEDGE BASE
//         </h1>
//         <p className="text-sm text-gray-700 text-center mb-8">
//           Everything you need to know about modern beekeeping in one place
//         </p>

//         {/* Mobile View: Horizontal Scrolling */}
//         {/* Mobile View: Horizontal Scrolling */}
// <div className="block md:hidden">
//   <Swiper
//     slidesPerView={"auto"}
//     spaceBetween={10}
//     freeMode={true}
//     autoplay={{
//       delay: 2500,
//       disableOnInteraction: false,
//     }}
//     modules={[FreeMode, Autoplay]}
//     className="px-2"
//   >
//     {blogPosts.map((post) => (
//       <SwiperSlide
//       onClick={()=>handleClick(blogPosts.id)}
//         key={post.id}
//         className="min-w-[280px] max-w-[300px]"
//       >
//         <div className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
//           <img src={post.thumbnail} alt={post.title} className="w-full h-40 object-cover" />
//           <div className="p-4 flex flex-col flex-grow">
//             <div className="text-gray-600 text-sm mb-2">{post.date}</div>
//             <h2 className="text-lg font-bold text-gray-800 mb-2">{post.title}</h2>
//             <p className="text-gray-700 text-sm flex-grow">{post.summary}</p>
//           </div>
//         </div>
//       </SwiperSlide>
//     ))}
//   </Swiper>
// </div>

// {/* Desktop View: Grid Layout */}
// <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
//   {blogPosts.map((post) => (
//     <div onClick={()=>{handleClick(post.id)}} key={post.id} className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
//       <img src={post.thumbnail} alt={post.title} className="w-full h-48 object-cover" />
//       <div className="p-6 flex flex-col flex-grow">
//         <div className="text-gray-600 text-sm mb-2">{post.date}</div>
//         <h2 className="text-xl font-bold text-gray-800 mb-3">{post.title}</h2>
//         <p className="text-gray-700 flex-grow">{post.summary}</p>
//       </div>
//     </div>
//   ))}
// </div>

//     </div>
//     </div>
//   );
// };

// export default KnowledgeHub;

import React, { useState, useEffect } from "react";
import { ref, get } from "firebase/database";
import { database as db } from "../../FirebaseConfig";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const globalStyles = `
  .scrollbar-hide::-webkit-scrollbar { display: none; }
  .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
  @keyframes meteor {
    0% { transform: translate(-200px, -200px) rotate(45deg); opacity: 0; }
    10% { opacity: 0.7; }
    100% { transform: translate(500px, 500px) rotate(45deg); opacity: 0; }
  }
  .meteor {
    position: absolute;
    width: 100px; height: 1px;
    background: linear-gradient(90deg, #d97706, transparent);
    animation: meteor 3s linear infinite;
    pointer-events: none;
  }
`;

const BlogCard = ({ post, onClick }) => (
  <motion.div
    whileHover={{ y: -5 }}
    // Optimization: Height reduced to 300px
    className="flex-shrink-0 w-[240px] md:w-[280px] bg-white/90 backdrop-blur-sm rounded-lg overflow-hidden shadow-md cursor-pointer snap-center flex flex-col h-[300px] border border-yellow-100"
    onClick={() => onClick(post.id)}
  >
    {/* Optimization: Image height h-32 */}
    <div className="relative h-32 overflow-hidden group">
      <img
        src={post.thumbnail}
        alt={post.title}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute top-2 left-2 bg-yellow-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm">
        {post.date}
      </div>
    </div>

    <div className="p-4 flex flex-col flex-grow">
      <h2 className="text-base font-bold text-gray-800 mb-1 leading-tight line-clamp-1">
        {post.title}
      </h2>
      <p className="text-gray-600 text-xs leading-relaxed line-clamp-3 flex-grow">
        {post.summary}
      </p>
      
      <div className="mt-2 pt-2 border-t border-gray-100 flex items-center justify-between">
        <span className="text-yellow-600 font-semibold text-xs">Read Article</span>
        <span className="text-yellow-500 text-sm">→</span>
      </div>
    </div>
  </motion.div>
);

const KnowledgeHub = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const snapshot = await get(ref(db, "blogs"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          setBlogPosts(Object.keys(data).map((key) => ({ id: key, ...data[key] })));
        }
      } catch (error) { console.error(error); }
      setLoading(false);
    };
    fetchBlogs();
  }, []);

  return (
    // Optimization: Reduced Padding py-8
    <div className="relative bg-gradient-to-br from-yellow-50 via-amber-50 to-orange-50 py-8 overflow-hidden">
      <style>{globalStyles}</style>

      {/* Meteor Effects (Reduced count for performance) */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="meteor"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 w-full  mx-auto px-4">
        {/* Optimization: Reduced margins */}
        <div className="text-center mb-6">
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">
            TGHC <span className="text-yellow-600">Knowledge Base</span>
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Modern beekeeping insights.
          </p>
        </div>

        {loading ? (
          <div className="text-center text-yellow-600 text-sm">Loading...</div>
        ) : (
          <div className="flex overflow-x-auto gap-4 pb-4 px-2 scrollbar-hide snap-x snap-mandatory scroll-smooth">
            {blogPosts.map((post) => (
              <BlogCard key={post.id} post={post} onClick={(id) => navigate(`/blog?id=${id}`)} />
            ))}
            <div className="w-2 flex-shrink-0"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KnowledgeHub;